<template>
  <section class="housemaid-policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRule"
        :disabled="showBuyable"
        :model="formData">
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>{{ isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date' }}</span>
            <el-form-item
              v-if="isCancel"
              ref="pcy_expry_dt"
              :prop="checkRefer===1?'':'pcy_expry_dt'">
              <v-date-picker
                v-model="formData.pcy_expry_dt"
                :_45daysComfirm='true'
                :picker-options="pickerOptions"/>
            </el-form-item>
            <el-form-item
              v-else
              ref="pcy_cmnt_dt"
              :prop="checkRefer===1?'':'pcy_cmnt_dt'">
              <v-date-picker
                v-model="formData.pcy_cmnt_dt"
                :_45daysComfirm='true'
                :picker-options="pickerOptions"/>
            </el-form-item>
          </div>

          <div
            v-if="!isDoula"
            class="form-item form-half">
            <span>Period of Insurance</span>
            <el-form-item
              ref="period_of_cvr"
              prop="period_of_cvr">
              <!--            :disabled="isCancel"-->
              <v-radio-group
                v-model="formData.period_of_cvr"
                :border="true"
                :disabled="action!=0"
                :list="localAllOptions.period" />
            </el-form-item>
          </div>
        </div>
        <div
          v-if="!isDoula"
          class="form-item form-half">
          <span>Coverage</span>
          <el-form-item
            ref="coverage_id"
            prop="coverage_id">
            <v-select
              v-model="formData.coverage_id"
              :disabled="true"
              :list="coverageOptions" />
          </el-form-item>
        </div>
        <div
          v-if="!isCancel"
          class="form-item form-half">
          <span>Expected Insured Period</span>
          <!--          <span>{{ pcy_end_dt }}</span>-->
          <v-date-picker
            disabled
            :value="pcy_end_dt"/>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0"
          class="box">
          <h3>Insured Items</h3>
          <div class="form-item">
            <v-checkbox-group
              v-model="formData.benefits"
              :isColumn="false"
              :list="insuredItems" />
          </div>
        </div>
        <div
          v-if="benefitList.length>0&&!isRefer"
          class="box">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item form-half">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :isColumn="false"
                :list="benefitList"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <h2>Policyholder Detail</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="isrd_title"
                prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  :disabled="isCancel|| checkDisabled('isrd_title')"
                  :list="titleOptions" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Occupation</span>
              <el-form-item
                ref="occ_id"
                prop="occ_id">
                <v-select
                  v-model="formData.occ_id"
                  :disabled="isCancel"
                  :list="localAllOptions.occupation" />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="flex-sb form-half">
              <div class="form-item form-half">
                <span>Last Name</span>
                <el-form-item
                  ref="isrd_lst_nm"
                  prop="isrd_lst_nm">
                  <v-input
                    v-model="formData.isrd_lst_nm"
                    uppercase
                    :disabled="isCancel||checkDisabled('isrd_lst_nm')"/>

                </el-form-item>
              </div>
              <div class="form-item form-half">
                <span>First Name</span>
                <el-form-item
                  ref="isrd_fst_nm"
                  prop="isrd_fst_nm">
                  <v-input
                    v-model="formData.isrd_fst_nm"
                    uppercase
                    :disabled="isCancel||checkDisabled('isrd_fst_nm')"/>
                </el-form-item>
              </div>
            </div>
            <div class="form-item form-half">
              <span>Mobile Number</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  type="number"
                  :disabled="isCancel||checkDisabled('mobile_no')"/>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="flex-sb">
          <div class="form-item form-half">
            <span>Date of Birth</span>
            <el-form-item
              ref="isrd_dob"
              prop="isrd_dob">
              <v-birth-day
                v-model="formData.isrd_dob"
                :disabled="isCancel||checkDisabled('isrd_dob')"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              prop="email"
              :rules="rules.email"
            >
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')" />
            </el-form-item>
          </div>
        </div>

        <div class="form-item form-half">
          <span>HKID/Passport Number</span>
          <el-form-item
            ref="id_type"
            prop="id_type">
            <v-radio-group
              v-model="formData.id_type"
              :list="personalIdTypOptions"
              :disabled="isCancel||checkDisabled('id_type')"/>
          </el-form-item>
          <el-form-item
            ref="id_no"
            prop="id_no">
            <v-input
              v-model="formData.id_no"
              uppercase
              :disabled="isCancel||checkDisabled('id_no')"/>
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>Is your Correspondence Address same as Proposed Location of Risk?</span>
          <v-radio-group
            v-model="formData.is_addr_same_ind"
            border
            :list="yesNoOption"
            :disabled="isCancel"></v-radio-group>
        </div>

        <div class="flex-sb">

          <div class="card form-half">
            <span class="title">Correspondence Address</span>
            <address-form
              ref="cor-address-form"
              :formDataLock="formDataLock"
              :form="corAddressForm"
              :is-update="formData.is_addr_same_ind==1"
              :isRequired="isRequired"
              :formType="1"
              :notValid="checkRefer===2?false:true"
              :disabled="isCancel||showBuyable"
              @getFormData="getAddressForm"
              @update="handleUpdateAddress"
            />
          </div>
          <div class="card form-half">
            <span class="title">Proposed Location of Risk</span>
            <address-form
              ref="address-form"
              :formDataLock="formDataLock"
              :form="addressForm"
              :formType="1"
              :isRequired="isRequired"
              :notValid="checkRefer==2?false:true"
              :disabled="formData.is_addr_same_ind == 1||isCancel||showBuyable"
              @getFormData="getAddressForm" />
          </div>
        </div>
        <!--        <div class="flex-sb">-->
        <!--          <div class="card form-half">-->
        <!--            <span class="title">Proposed Location of Risk</span>-->
        <!--            <address-form-->
        <!--              ref="address-form"-->
        <!--              :formDataLock="formDataLock"-->
        <!--              :form="addressForm"-->
        <!--              :formType="1"-->
        <!--              :disabled="isCancel"-->
        <!--              @getFormData="getAddressForm" />-->
        <!--          </div>-->
        <!--          <div class="card form-half">-->
        <!--            <span class="title">Correspondence Address</span>-->
        <!--            <v-checkbox-->
        <!--              v-model="formData.is_addr_same_ind"-->
        <!--              :disabled="isCancel">Is your Correspondence Address same as Proposed Location of Risk?</v-checkbox>-->
        <!--            <address-form-->
        <!--              ref="cor-address-form"-->
        <!--              :formDataLock="formDataLock"-->
        <!--              :form="corAddressForm"-->
        <!--              :formType="1"-->
        <!--              :disabled="formData.is_addr_same_ind == 1||isCancel"-->
        <!--              @getFormData="getAddressForm" />-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="box">
          <h2>Domestic Helper's information</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="domestic_title"
                prop="domestic_title">
                <v-select
                  v-model="formData.domestic_title"
                  :list="titleOptions"
                  :disabled="isCancel"/>
              </el-form-item>
            </div>
            <!--            <div class="form-item form-half">-->
            <!--              <span>Name</span>-->
            <!--              <el-form-item-->
            <!--                ref="full_name"-->
            <!--                prop="full_name">-->
            <!--                <v-input-->
            <!--                  v-model="formData.full_name"-->
            <!--                  uppercase-->
            <!--                  :disabled="isCancel||checkDisabled('full_name')"/>-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <div class="flex-sb form-half">
              <div class="form-item form-half">
                <span>Last Name</span>
                <el-form-item
                  ref="domestic_lst_nm"
                  prop="domestic_lst_nm">
                  <v-input
                    v-model="formData.domestic_lst_nm"
                    uppercase/>
                </el-form-item>
              </div>
              <div class="form-item form-half">
                <span>First Name</span>
                <el-form-item
                  ref="domestic_fst_nm"
                  prop="domestic_fst_nm">
                  <v-input
                    v-model="formData.domestic_fst_nm"
                    uppercase/>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Date of Birth</span>
              <el-form-item
                ref="domestic_dob"
                prop="domestic_dob">
                <v-birth-day
                  v-model="formData.domestic_dob"
                  :disabled="isCancel"/>
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>HKID/Passport Number</span>
              <el-form-item
                ref="domestic_id_type"
                prop="domestic_id_type">
                <v-radio-group
                  v-model="formData.domestic_id_type"
                  :list="personalIdTypOptions"
                  :disabled="isCancel"/>
              </el-form-item>
              <el-form-item
                ref="domestic_id_no"
                prop="domestic_id_no">
                <v-input
                  v-model="formData.domestic_id_no"
                  uppercase
                  :placeholder="formData.domestic_id_type==1?'A123456(3), please input A1234563':''"
                  :disabled="isCancel||checkDisabled('domestic_id_no')"
                  class="mg-t-15" />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Nationality</span>
              <el-form-item
                ref="nationality_id"
                prop="nationality_id">
                <!-- <v-select
                v-model="formData.nationality_id"
                :list="localAllOptions.nationality"
                :disabled="isCancel"/> -->
                <v-select
                  v-model="formData.nationality_id"
                  :list="nationalityOptions" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Position / Duties</span>
              <el-form-item
                ref="duty_id"
                prop="duty_id">
                <!-- <v-select
                v-model="formData.duty_id"
                :list="localAllOptions.duties"
                :disabled="isCancel"/> -->
                <v-select
                  v-model="formData.duty_id"
                  :list="localAllOptions.duties"
                  :disabled="true"/>
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Monthly Salary</span>
              <el-form-item
                ref="monthly_salary"
                prop="monthly_salary">
                <!-- <v-input
                v-model="formData.monthly_salary"
                :disabled="isCancel"
                append="HKD" /> -->
                <v-input
                  v-model="formData.monthly_salary"
                  :disabled="isCancel||checkDisabled('monthly_salary')"
                  append="HK$"
                />
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="box">
          <h2>Upload Document</h2>
          <div
            v-if="editType==3"
            class="flex-sb">
            <div
              class="form-item form-half">
              <span >Renewal Letter（Insurer）</span>
              <el-form-item
                ref="renewal_letter_insurer_path_id"
                prop="renewal_letter_insurer_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable"
                  :fileData="formData.renewal_letter_insurer"
                  :otherData="{
                    target: 'renewal_letter_insurer',
                    idKey: 'renewal_letter_insurer_path_id',
                    nameKey: 'renewal_letter_insurer_path',
                    type:'renewal_letter_insurer_path'
                  }"
                  @delete="handlerUploadDelete"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.id_type_pic"
                  :file-list="fileList"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    type:'id_type_pic_path'
                  }"
                  :disabled="isCancel||showBuyable"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Domestic Helper HKID/ Passport </span>
              <el-form-item
                ref="domestic_id_type_pic_path_id"
                prop="domestic_id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :fileData="formData.domestic_id_type_pic"
                  :file-list="fileList"
                  :otherData="{
                    target: 'domestic_id_type_pic',
                    idKey: 'domestic_id_type_pic_path_id',
                    nameKey: 'domestic_id_type_pic_path',
                  }"
                  :disabled="isCancel||showBuyable"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerUploadDelete"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <span>Additional Documents</span>
            <file-container
              v-for="(item, index) in formData.other_file"
              :key="index"
              :fileData="item"
              :file-list="fileList"
              :otherData="{
                index,
                type: 'other_file'
              }"
              titleName= "Additional Documents"
              :disabled="isCancel||showBuyable"
              :edit="true"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
            <v-upload
              :file-list="fileList"
              :otherData="{
                type: 'other_file',
              }"
              :disabled="isCancel||showBuyable"
              @uploadSuccess="handlerUploadSuccess" />
          </div>
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import {mapActions, mapState} from 'vuex'
import MixinSame from '@/mixins/same'

export default {
  name: 'HousemaidPolicyForm',
  components: {
    AddressForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    action:{
      type: [String, Number],
      default: 0 //0正常 1 - endorse, 2 - cancel
    },
    form: {
      type: Object,
      default: null
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type: Number,
      default: 0 // 0 - 正常 edit， 1 - reply refer, 2 - 确认refer
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    return {

      pickerOptions: {
        disabledDate(time){
          return time.getTime()<Date.now()
        }
      },
      yesNoOption: [
        {
          name: 'Yes',
          id: 1
        },
        {
          name: 'No',
          id: 0
        }
      ],
      formData: {
        is_virgin: 0, // 判斷是否二次投保
        class_id: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        period_of_cvr: '',
        pcy_period:'',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_dob:'',
        isrd_dob_date:'',
        isrd_fst_nm: '',
        id_type: 1,
        id_no: '',
        occ_id: '',
        mobile_no: '',
        email: '',
        is_addr_same_ind: 0,
        domestic_title: '',
        full_name: '',
        domestic_lst_nm:'',
        domestic_fst_nm:'',
        domestic_id_type: 1,
        domestic_id_no: '',
        duty_id: '',
        domestic_dob: '',
        nationality_id: '',
        monthly_salary: '',
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        domestic_id_type_pic_path: '',
        domestic_id_type_pic_path_id: '',
        other_file: [],
        id_type_pic: {},
        domestic_id_type_pic: {},
        benefits: [],
        coverage_id: '',
        domestic_age: '',
        step:'',
        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      corAddressForm: {},
      formDataLock: 0,
      subForm: {
        'address-form': false,
        'cor-address-form': false
      },
      otherData: {},
      extraRules:{
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ]
      }
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
            // if(item.is_selected==1)
            //   this.formData.benefits.push(item.id)
          }
        })
      }
      return arr||[]
    },
    formRule() {
      // const ruleDataOptions = this.rules
      // let keys= Object.keys(ruleDataOptions)
      // if (this.checkRefer == 1) {
      //   keys.forEach(k => {
      //     ruleDataOptions[k].forEach(item => {
      //       item.required = false
      //     })
      //   })
      // }
      //
      // return ruleDataOptions
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)
      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })


      // Object.keys(this.ruleRequestData).some(key => {
      //   // Object.keys(rulesOption).some(keys => {
      //   //   if(key==keys)
      //   rulesOption[key][0].required = true
      //   // })
      // })
      console.log('checkRefer',this.checkRefer)
      return this.checkRefer ===2 ? this.rules : rulesOption
    },
    localAllOptions() {
      return this.allOptions21
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions21
      return benefits||[]
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    isDriver() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { is_driver } = data || {}
      return !!is_driver
    },
    // nationalityOptions() {
    //   let list = this.localAllOptions.nationality || []
    //   if(this.isDoula) {
    //     list = list.filter(item => item.doula == 1)
    //   }
    //   if(this.isPartTime) {
    //     list = list.filter(item => item.part_time == 1)
    //   }
    //   if(this.isDriver) {
    //     list = list.filter(item => item.id == 1)
    //   }
    //   return list
    // },
    coverageOptions() {
      const { coverage = [] } = this.localAllOptions
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    // 判斷是否二次投保
    disabledVirgin() {
      const { is_virgin } = this.formData
      return is_virgin === 1? false: true
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt,pcy_period,pcy_expry_dt,ins_end_dt } = this.formData
      let date = ''
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).subtract(1,'day').add(period_of_cvr, 'year').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).subtract(1,'day').add(Number(period_of_cvr)*10, 'month').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      if(this.isEndorsement)
        return  ins_end_dt?ins_end_dt:pcy_expry_dt
      // console.log('pcy_period',pcy_period)
      // if(pcy_period==0)
      //   date = pcy_expry_dt
      // else
      //   date=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('DD-MM-YYYY'):''


      return ''
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform ==2
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {

        if(val) {
          if(val.nationality_id) {
            this.updateNationalityOptions(val.nationality_id)
          }

          const formValue = JSON.parse(JSON.stringify(val))
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          // Object.keys(this.formData).some(key => {
          //   if(key in val) {
          //     this.formData[key] = val[key]
          //   }
          // })
          let {quote_coverage_list} = val||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits= [...new Set( this.formData.benefits)]
          this.formData.is_addr_same_ind = formValue.is_addr_same_ind
          // 後臺可以用 passport ？ 注釋
          // if(formValue.id_type != 1) {
          //   this.formData.id_no = ''
          // }
          if(formValue.id_type_pic) {
            const { path, id } = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          if(formValue.domestic_id_type_pic) {
            const { path, id } = formValue.domestic_id_type_pic
            this.formData.domestic_id_type_pic_path = path
            this.formData.domestic_id_type_pic_path_id = id
          }
          let date = new Date(this.formData.pcy_expry_dt).getTime()
          let dateCmnt = new Date(this.formData.pcy_cmnt_dt).getTime()

          if(date<Date.now())
          {
            this.formData.pcy_expry_dt =''
          }
          if(dateCmnt<Date.now() && this.editType != 3)
          {
            this.formData.pcy_cmnt_dt =''
          }
          if(this.isCancel)
          {
            // this.formData.pcy_expry_dt =''
          }
          // let {step} = val
          // if(step==0)
          //   this.formData.monthly_salary = ''
          // const { monthly_salary } = val
          // if(!monthly_salary) {
          //   this.formData.monthly_salary = ''
          // }
          this.handler().handlerAddress(formValue)
        }
      }
    },
    'formData.is_addr_same_ind': {
      deep: true,
      handler(val) {
        // 清空地址組件校驗
        if(val==1){
          this.$nextTick(()=>{
            let params = this.$refs['cor-address-form'].formData
            this.handleUpdateAddress(params)
          })
          // this.handler().handlerAddress(this.corAddressForm)
        }
        // this.$refs['address-form'].clearValidate()
      }
    },
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    checkValueBool(value) {
      if(value === '' || value === null || value === undefined) {
        return false
      }
      return Boolean(value)
    },
    submitForm(otherData = {}) {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          this.otherData = otherData
          if(this.formData.is_addr_same_ind) {
            // 這裏只需要校驗一個地址表單
            // debugger
            this.$refs['cor-address-form'].submitForm('cor-address-form')
          }
          else {
            // debugger
            Object.keys(this.subForm).some(key => {
              this.subForm[key] = false
              this.$refs[key].submitForm(key)
            })
            if(Object.values(this.subForm).some(item => item === false)) {
              return
            }
            let {benefits=[]} = this.formData||{}
            const uniqueArray = benefits.filter((value, index, self) => {
              return self.indexOf(value) === index
            })
            const result = {
              ...this.formData,
              is_addr_same_ind: this.formData.is_addr_same_ind? 1: 0,
              benefits:uniqueArray
              // id_type: 1
            }
            this.$emit('getFormData', result, otherData)
          }
        }
        else {
          console.log(rules)
          this.scrollToValidDom(rules)
        }
      })
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      if(this.formData.is_addr_same_ind) {
        // 這裏只需要校驗一個地址表單
        // debugger
        this.$refs['cor-address-form'].submitFormNoVaild('cor-address-form')
      }
      else {
        // debugger
        Object.keys(this.subForm).some(key => {
          this.subForm[key] = false
          this.$refs[key].submitFormNoVaild(key)
        })
        // if(Object.values(this.subForm).some(item => item === false)) {
        //   return
        // }
        let {benefits=[]} = this.formData||{}
        const uniqueArray = benefits.filter((value, index, self) => {
          return self.indexOf(value) === index
        })
        const result = {
          ...this.formData,
          is_addr_same_ind: this.formData.is_addr_same_ind? 1: 0,
          benefits:uniqueArray
          // id_type: 1
        }
        this.$emit('getFormData', result, otherData)
      }
    },
    handleUpdateAddress(data){
      const params = {}
      Object.keys(this.addressForm).some(key => {
        params[key] = data[key]
      })
      this.addressForm = params
      this.formDataLock += 1
    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'address-form') {
        Object.assign(this.formData, data)
      }
      else {
        this.handler().handlerAddressResult(data)
        if(this.formData.is_addr_same_ind) {
          const result = {
            ...this.formData,
            ...data,
            is_addr_same_ind: this.formData.is_addr_same_ind? 1: 0,
            // id_type: 1
          }
          // debugger
          this.$emit('getFormData', result, this.otherData)
        }
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if(type !== 'other_file') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, nameKey, path)
        this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerUploadDelete({ otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData

      if(type !== 'other_file') {
        this.$set(this.formData, idKey, '')
        this.$set(this.formData, nameKey, '')
        this.$set(this.formData, target, null)
        this.$refs['form'].validateField(idKey)
      }
    },
    handlerDeleteFile(otherData) {
      const { type, index } = otherData
      if(type === 'other_file') {
        this.formData.other_file.splice(index, 1)
      }else{

      }
    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            cor_addr_room,
            cor_addr_floor,
            cor_addr_block,
            cor_addr_building,
            cor_addr_street,
            cor_addr_district,
            cor_addr_area,
            cor_addr_region
          } = data
          const obj = {
            addr_room: cor_addr_room,
            addr_floor: cor_addr_floor,
            addr_block: cor_addr_block,
            addr_building: cor_addr_building,
            addr_street: cor_addr_street,
            addr_district: cor_addr_district,
            addr_area: cor_addr_area,
            addr_region: cor_addr_region,
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })
          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(params))
          this.corAddressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            cor_addr_room: addr_room,
            cor_addr_floor: addr_floor,
            cor_addr_block: addr_block,
            cor_addr_building: addr_building,
            cor_addr_street: addr_street,
            cor_addr_district: addr_district,
            cor_addr_area: addr_area,
            cor_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.extra_checkbox{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
